import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Environment } from '../../environments/environment';

@Injectable()
export class DataService {

  constructor(private http: HttpClient) {}

  getToken(username: string, password: string, company: string): Promise<any> {
    return this.http.post(`${Environment.apiUrl}/token`, { username, password, company }).toPromise().catch(err => null);
  }

  getTokenSSO(company: string, ssoToken: string): Promise<any> {
    let isSSOLogin = true;
    return this.http.post(`${Environment.apiUrl}/token`, { company, ssoToken, isSSOLogin }).toPromise().catch(err => null);
  }

  getSSOBaseUrl(): Promise<any> {
    return this.http.get(`${Environment.apiUrl}/token/ssobaseurl`).toPromise().catch(err => null);
  }

  getTour(deviceId: number, id: number): Promise<any> {
    return this.http.get(`${Environment.apiUrl}/tours/${deviceId}/${id}`).toPromise().catch(err => null);
  }

  getTourTemplate(tourTemplateId: number): Promise<any> {
    return this.http.get(`${Environment.apiUrl}/tour-templates/${tourTemplateId}`).toPromise().catch(err => null);
  }

  getTourTemplates(): Promise<any> {
    return this.http.get(`${Environment.apiUrl}/tour-templates`).toPromise().catch(err => []);
  }

  createTourTemplate(tourTemplate: any): Promise<any> {
    return this.http.post(`${Environment.apiUrl}/tour-templates`, tourTemplate).toPromise();
  }

  updateTourTemplate(tourTemplate: any): Promise<any> {
    return this.http.put(`${Environment.apiUrl}/tour-templates`, tourTemplate).toPromise();
  }

  getVehicles(): Promise<any> {
    return this.http.get(`${Environment.apiUrl}/vehicles`).toPromise().catch(err => []);
  }

  getTimeZones(): Promise<any> {
    return this.http.get(`${Environment.apiUrl}/time-zones`).toPromise().catch(err => []);
  }

  getDbVersion(): Promise<any> {
    return this.http.get(`${Environment.apiUrl}/dbversion`).toPromise().catch(err => []);
  }

  getOrderTemplate(orderTemplateId: number): Promise<any> {
    return this.http.get(`${Environment.apiUrl}/order-templates/${orderTemplateId}`).toPromise().catch(err => null);
  }

  createOrderTemplate(orderTemplate: any): Promise<any> {
    return this.http.post(`${Environment.apiUrl}/order-templates`, orderTemplate).toPromise();
  }

  updateOrderTemplate(orderTemplate: any): Promise<any> {
    return this.http.put(`${Environment.apiUrl}/order-templates`, orderTemplate).toPromise();
  }

  getCustomer(id, position, customerid): Promise<any> {
    return this.http.get(`${Environment.apiUrl}/customerunloadpoints/${customerid}/${position}/${id}`).toPromise().catch(err => null);
  }

  getCustomers(opts): Promise<any> {
    let filter = opts.filter || {};
    let params = Object.keys(filter).reduce((p, k) => filter[k] ? p.set(k, filter[k]) : p, new HttpParams());
    params = ['skip', 'take'].reduce((p, k) => opts[k] ? p.set(k, opts[k]) : p, params);
    return this.http.get(`${Environment.apiUrl}/customerunloadpoints`, { params }).toPromise().catch(err => []);
  }

  getProducts(): Promise<any> {
    return this.http.get(`${Environment.apiUrl}/products`).toPromise().catch(err => []);
  }

  getLoadLocation(id): Promise<any> {
    return this.http.get(`${Environment.apiUrl}/loadlocations/${id}`).toPromise().catch(err => null);
  }

  getLoadLocations(opts): Promise<any> {
    let filter = opts.filter || {};
    let params = Object.keys(filter).reduce((p, k) => filter[k] ? p.set(k, filter[k]) : p, new HttpParams());
    params = ['skip', 'take'].reduce((p, k) => opts[k] ? p.set(k, opts[k]) : p, params);
    return this.http.get(`${Environment.apiUrl}/loadlocations`, { params }).toPromise().catch(err => []);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/data.service.ts